import React, { Component } from 'react'
import { ThePermission } from 'src/containers/ThePermission';
import {
    CDataTable,
    CButton,
    CTooltip,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { helps } from '../../_helpers';
import configs from 'src/appConfigs';
import Loading from 'src/containers/_loading';
import DocCategoriesForm from 'src/views/docs/DocCategoriesForm';

class DocsCategories extends Component {

    constructor(props) {
        super(props);

        this.state = {
        }

        this.pageChange = this.pageChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
    }

    componentDidMount() {

    }

    pageChange = (newPage) => {
        var currentPage = this.state.currentPage;
        currentPage !== newPage && this.props.history.push(`/users?page=${newPage}`)
    }

    handleChange(field, e) {
        var value = e.target.value;
        if (value === "true" || value == "false") {
            value = JSON.parse(value);
        }
        this.setState({
            [field]: value
        });
    }

    handleSelect(selectOPtions, field) {
        this.setState({
            [field]: selectOPtions,
        });
        console.log(this.state)
    }

    render() {
        const { categories, users, user } = this.props;

        let _categories = !helps.isEmpty(categories) ? categories : [];
        const fields = [
            { key: 'inc', label: '#', _classes: 'text-center', _style: { width: '10px' }, filter: false, sorter: false },
            { key: 'name', label: 'Tên loại văn bản', _classes: 'font-weight-bold', _style: { width: '25%' } },
            { key: 'code', label: 'Viết tắt / Ký hiệu', _style: { width: '10%' } },
            { key: 'description', label: 'Mô tả', _style: { width: '50%' } },
            { key: 'create_by_alias', label: 'Tạo Bởi', _style: { align: 'center' }, filter: false },
            { key: 'actions', label: 'Thao Tác', _classes: 'text-center', _style: { width: '10%' }, filter: false, sorter: false },
        ]
        if (this.props.loading_cat) {
            return (
                <Loading></Loading>
            );
        }
        return (
            <CDataTable
                key={'categories_' + _categories.length}
                items={_categories}
                fields={fields}
                columnFilter
                tableFilter={{ label: 'Tìm Kiếm: ', placeholder: '...', _classes: 'font-weight-bold' }}
                itemsPerPageSelect={configs.itemsPerPageSelect}
                itemsPerPage={100}
                hover
                sorter
                pagination
                striped
                scopedSlots={{
                    'inc': (item, inc) => {
                        return (
                            <td className="py-2" id={item.id}>
                                {inc + 1}
                            </td>
                        )
                    },
                    'name': (item) => {
                        return (
                            <td className="py-2">
                                <b>{item.name}</b>
                            </td>
                        )
                    },
                    'code': (item) => {
                        return (
                            <td className="py-2">
                                <b>{item.code}</b>
                            </td>
                        )
                    },
                    'description': (item) => {
                        return (
                            <td className="py-2">
                                <b>{item.description}</b>
                            </td>
                        )
                    },
                    'create_by_alias': (item) => {
                        let create_by_alias = helps.getUserAlias(users, item.create_by);
                        return (
                            <td className="py-2">
                                {create_by_alias}<br />
                                {helps.formatDate_from_Timestamp(item.create_date)}
                            </td>
                        )
                    },
                    'actions':
                        (item) => {
                            return (
                                <td className="py-2 text-center">
                                    <ThePermission {... this.props} component="docs" action="edit">
                                        <CTooltip content={"Cập nhật thông tin Nhóm: " + item.name}>
                                            <CButton
                                                color="primary"
                                                size="sm"
                                                title="Cập nhật thông tin"
                                                onClick={() => { this.props.toggleModal(item.id) }}
                                            >
                                                <CIcon name="cil-pen-nib"></CIcon>
                                            </CButton>
                                        </CTooltip>
                                        <DocCategoriesForm
                                            {... this.props}
                                            modals={this.props.modals}
                                            form_header={"Cập nhật thông tin Nhóm: " + item.name}
                                            item={item.id}
                                            category={item}
                                            toggleModal={() => { this.props.toggleModal(item.id) }}
                                        />
                                    </ThePermission>
                                </td>
                            )
                        },
                }}
            />

        )
    }
}


export default DocsCategories;
